import { LdapDefaultValuesComponent } from './ldap-default-values/ldap-default-values.component';
import { LdapAttributeMappingComponent } from './ldap-attribute-mapping/ldap-attribute-mapping.component';
import { SharedModule } from './../../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BzTabModule } from './../../shared/components/tab/tab.module';
import { LdapBasicConfigurationComponent } from './ldap-basic-configuration/ldap-basic-configuration.component';
// Angular Imports
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

// This Module's Components
import { SecurityLdapComponent } from './security-ldap.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LdapTestResultsComponent } from './ldap-test-results/ldap-test-results.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        BzTabModule,
        BrowserModule,
        FormsModule,
        SharedModule
    ],
    declarations: [
        SecurityLdapComponent,
        LdapBasicConfigurationComponent,
        LdapAttributeMappingComponent,
        LdapDefaultValuesComponent,
        LdapTestResultsComponent
    ],
    exports: [
        SecurityLdapComponent,
        LdapBasicConfigurationComponent,
        LdapAttributeMappingComponent,
        LdapDefaultValuesComponent,
        LdapTestResultsComponent
    ],
    schemas : [CUSTOM_ELEMENTS_SCHEMA]
})
export class SecurityLdapModule {

}
